import React from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
import APIS from "../../constant/EndPoint";
import DateRangePicker from "../Reusable/DateRangePicker";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { classNames } from "../../utils/classNames";

const RunsheetFilter = (props: any) => {
  const {
    register,
    setValue,
    getValues,
    errors,
    watch,
    clearErrors,
    isFilterVisible,
    handleFilterReset,
    reset,
  } = props;
  return (
    <div
      className={classNames(
        props?.isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      {isFilterVisible ? (
        <div className={tw`grid grid-cols-4  gap-x-4 mx-4`}>
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <ComboboxInput
            url={APIS.VEHICLE}
            queryKey={"vehicle"}
            register={register("vehicle")}
            errors={errors?.vehicle}
            name={"vehicle"}
            label={"Vehicle Number"}
            setValue={setValue}
            placeholder={"Search vehicle"}
            getValues={getValues}
            props={{ is_active: true }}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.DRIVER}
            queryKey={"driver"}
            register={register("driver")}
            errors={errors?.driver}
            name={"driver"}
            label={"Driver"}
            setValue={setValue}
            placeholder={"Search driver"}
            props={{ is_active: true }}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"branch"}
            register={register("destination_branch")}
            errors={errors?.destination_branch}
            name={"destination_branch"}
            label={"Branch"}
            props={{
              is_active: true,
            }}
            setValue={setValue}
            placeholder={"Search branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
      ) : (
        ""
      )}
      <button className={tw`absolute -top-5 right-5`} onClick={() => reset()}>
        Reset
      </button>
    </div>
  );
};

export default RunsheetFilter;
